import styles from "./Avatar.module.css";
import { CloudinaryImage } from "../Cloudinary";
import { CSSProperties } from "react";

interface Props {
  src: string | undefined | null;
  name?: string;
  size?: number;
  disabled?: boolean;
  style?: CSSProperties;
}

export default function ProfilePic({ src, name, size = 44, style }: Props) {
  if (!src) {
    return <ProfilePicPlaceholder name={name} size={size} />;
  }

  const containerStyle = { width: size, height: size };

  return (
    <span className={styles.AvatarPic} style={{ ...containerStyle, ...style }}>
      <CloudinaryImage
        src={src}
        transformations={[`w_${size}`, `h_${size}`, "c_fill"]}
      />
    </span>
  );
}

interface ProfilePicPlaceholderProps {
  size?: number;
  name: string;
}

function ProfilePicPlaceholder({
  name,
  size = 44,
}: ProfilePicPlaceholderProps) {
  const initial = name && name[0];

  return (
    <span
      className={styles.AvatarPicPlaceholder}
      style={{
        width: size,
        height: size,
      }}
    >
      {initial}
    </span>
  );
}
